import { useEffect, useRef } from 'react';

import { useAtomValue, Atom } from 'jotai';

/**
 * Store the latest value of an atom, to be used in cases such as closures
 * to avoid accessing stale values
 * @param atom
 * @returns
 */
function useSyncedAtomRef<T>(atom: Atom<T>): React.MutableRefObject<T> {
  const currentValue = useAtomValue(atom);
  const valueRef = useRef<T>(currentValue);

  useEffect(() => {
    valueRef.current = currentValue;
  }, [currentValue]);

  return valueRef;
}

export { useSyncedAtomRef };
